import {
  createAddon,
  IAddon,
  registerOperationHandler
} from '@ms/items-view/lib/private/addons/registerOperationHandler';

import {
  IItemCacheDispatch
} from '@ms/items-view/lib/private/store/actions/ItemCacheActions';

import {
  getItemsOperation
} from '@ms/items-view/lib/private/operations/getItems';

import {
  spDataSourceConfigurationFacet,
  spPrefetchDataConfigurationFacet,
  spFilterableSetFacet
} from './Facets';
import { waitForPageLoad } from '@ms/items-view/lib/private/operations/pageLoad';
import {
  spItemFullUrlKeyFacet
} from './Keys';
export { spDataSourceConfigurationFacet };
export { spPrefetchDataConfigurationFacet };
import { itemsViewPerfMarkers, PerfMark } from '../utilities/logging/performance/PerfMarkers';
import { itemsViewSearchControl } from '@ms/items-view/lib/private/controls/itemsViewSearchControl';
import { itemsViewSearchControlHandler, searchViewSearchControlHandler } from '../controls/itemsViewSearchControl';
import {
  spItemKeyFacet,
  spFolderItemSetKeyFacet,
  spSearchItemSetKeyFacet
} from './Keys';
import { registerControlHandler } from '@ms/items-view/lib/private/addons/registerControlHandler';
import { shareActionControl } from '@ms/items-view/lib/private/controls/shareActionControl';
import { filteredItemSetControl } from '@ms/items-view/lib/private/controls/filteredItemSetControl';
import { shareActionControlHandler, itemFullUrlshareActionControlHandler } from '../controls/shareActionControl';
import { getFeatureChecker } from '../models/features/getFeatureChecker';
import { getNormalizedFolderKey } from '../models/keys/getNormalizedFolderKey';
import { getFilteredItemSetKey } from '../models/keys/getFilteredItemSetKey';
import { graphFileHandlerAddon } from '@ms/items-view-addon-graph/lib/GraphFileHandlerAddon';
import { getAllAncestorItems } from './operations/getAllAncestorItems';
import { spItemIsReadOnlyControlHandler } from '../handlers/controls/spItem/itemIsReadOnlyControlHandler';
import { itemIsReadOnlyControl } from '@ms/items-view/lib/private/controls/itemIsReadOnlyControl';
import { spFolderItemSetFilteredItemSetControlHandler } from '../handlers/controls/spFolderItemSet/filteredItemSetControlHandler';
import { spSearchItemSetGetItemsOperationHandler } from '../handlers/operations/spSearchItemSet/getItemsOperationHandler';
import { sharePointReadOnlyAddon } from './sharePointReadOnlyAddon';
import { handleError } from '@ms/items-view/lib/private/operations/handleError';
import { asModuleWithRetries } from '@ms/utilities-async/lib/decorators/asModuleLoad';

const loadSpAddonDataOnlyDeferred = asModuleWithRetries(
  () => import(/* webpackChunkName: 'spaddondataonlydeferred' */'./SpAddonDataOnlyDeferred'),
  {
    chunkName: 'spaddondataonlydeferred'
  }
);

export * from './Keys';

export { spFilterableSetFacet };

export { getFilteredItemSetKey };

export { getFeatureChecker };

export { getAllAncestorItems };

export { getNormalizedFolderKey };

/**
 * @public
 */
export const sharePointAddonDataOnly: IAddon = createAddon(() => {
  return async (dispatch: IItemCacheDispatch) => {
    PerfMark.mark(itemsViewPerfMarkers.appStart.start);

    // This addOn should be limited to data retrieval only and not know anything about
    // the UX. To dispatch web specific control handlers use SpAddonly.ts

    dispatch(registerControlHandler(spFolderItemSetKeyFacet, itemsViewSearchControl)(
      itemsViewSearchControlHandler
    ));

    dispatch(registerControlHandler(spSearchItemSetKeyFacet, itemsViewSearchControl)(
      searchViewSearchControlHandler
    ));

    dispatch(registerOperationHandler(spSearchItemSetKeyFacet, getItemsOperation)(
      spSearchItemSetGetItemsOperationHandler
    ));

    dispatch(sharePointReadOnlyAddon);

    dispatch(registerControlHandler(spItemKeyFacet, shareActionControl)(
      shareActionControlHandler
    ));

    dispatch(registerControlHandler(spItemFullUrlKeyFacet, shareActionControl)(
      itemFullUrlshareActionControlHandler
    ));

    dispatch(graphFileHandlerAddon);

    dispatch(registerControlHandler(spItemKeyFacet, itemIsReadOnlyControl)(
      spItemIsReadOnlyControlHandler
    ));

    dispatch(registerControlHandler(spFolderItemSetKeyFacet, filteredItemSetControl)(
      spFolderItemSetFilteredItemSetControlHandler
    ));

    await dispatch(waitForPageLoad({
      waitIndefinitely: true
    }));

    try {
      const {
        spDataOnlyAddonDeferred
      } = await loadSpAddonDataOnlyDeferred();

      if (!spDataOnlyAddonDeferred) {
        throw new Error(`Couldn't load extended SharePoint features.`);
      }

      dispatch(spDataOnlyAddonDeferred);
    } catch (e) {
      dispatch(handleError({
        error: e
      }));
    }
  };
});
